import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgInfo} from "~/assets/svg/info.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmInfoIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgInfo id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
